import React from 'react';
import { Avatar, AvatarProps } from '@material-ui/core';
import { first } from 'lodash';
import { getAvatarColour } from '../screens/general/user-profile/components/Avatar';

interface ProfileAvatarProps extends AvatarProps {
  profile: {
    lastName: string;
    preferredName: string;
    avatarUrl?: string | null;
  };
  size?: 'extrasmall' | 'small' | 'medium';
}

const sizeMap = {
  extrasmall: { width: 20, height: 20, fontSize: '9px' },
  small: { width: 24, height: 24, fontSize: '10px' },
  medium: { width: 28, height: 28, fontSize: '11px' },
};

export function ProfileAvatar({ profile, size, style, ...remainProps }: ProfileAvatarProps) {
  const name = `${profile.preferredName} ${profile.lastName}`;
  const sizeStyle = size ? sizeMap[size] : {};

  if (profile.avatarUrl) {
    return <Avatar alt={name} src={profile.avatarUrl} {...remainProps} style={{ ...sizeStyle, ...style }} />;
  }
  const shortenName = `${first(profile.preferredName)}${first(profile.lastName)}`.toUpperCase();
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('');
  const colour = getAvatarColour(initials);
  return (
    <Avatar
      {...remainProps}
      style={{
        fontSize: '1rem',
        fontWeight: 'bold',
        backgroundColor: `#${colour}`,
        ...sizeStyle,
        ...style,
      }}
    >
      {shortenName}
    </Avatar>
  );
}
